const containsChildElement = (parentNode, childNode) => {
  if (parentNode.contains) {
    return parentNode.contains(childNode);
  }

  return parentNode.compareDocumentPosition(childNode) % 16;
};

export default containsChildElement;
